import { config, Config } from '../config';

const currentOrigin = () => window.location.origin;

let configCache: Config;
const getConfig = () => {
  if (typeof configCache !== 'undefined') return configCache;
  const origin = currentOrigin();

  let conf = getConfigByOrigin(config, origin);

  // Falls back to `local` for any origin with no entry above, which personal dev stacks rely on
  // (the `dev` entry keeps a literal `{user}` placeholder, so it never matches). Note that
  // `config.local` points `smithyApi` at alpha: an origin that is missing an entry does not fail
  // loudly, it silently calls the alpha API and dies on CORS. A new stage or ITL target must be
  // added to `config` or it will look like an alpha routing bug.
  if (!conf) {
    conf = config.local;
  }

  configCache = conf;

  return conf;
};

export const getStageByOrigin = () => {
  const origin = currentOrigin();

  const stages = Object.entries(config)
    .filter(([_, entry]) => {
      return entry.urls.some((url) => {
        return origin.includes(url);
      });
    })
    .map(([stage, _]) => stage);

  return stages.length > 0 ? stages[0] : null;
};

export const getConfigByOrigin = (config: { [key: string]: Config }, origin: string) => {
  const configEntries = Object.values(config).filter((entry) => {
    return entry.urls.some((url) => {
      return origin.includes(url);
    });
  });

  return configEntries.length > 0 ? configEntries[0] : null;
};

// Note: This is only used when retrieving local dummy API files
export const getSiteUrl = () => {
  const urls = getConfig().urls;
  const matched = urls.reduce((matchedUrl: string | null, url: string) => {
    if (matchedUrl) return matchedUrl;
    return currentOrigin().includes(url) || url.includes(currentOrigin()) ? url : null;
  }, null);
  return matched;
};

export const getApiUrl = () => getConfig().api;

export const getSmithyApiUrl = () => getConfig().smithyApi;

export const getAnalyticsConfig = () => getConfig().analytics;

export const getAuthConfig = () => getConfig().auth;
